// BDG Popup — Mil Pennys. Mil Pesos.
(function() {
  'use strict';

  var STORAGE_KEY = 'bdg_popup_seen';
  var DELAY_MS    = 3000;

  var EXCLUDED = [
    '/products/penny-clogs',
    '/products/penny-pony',
    '/products/penny-black',
    '/products/penny-olive',
    '/cart',
    '/checkout',
    '/account'
  ];

  function shouldShow() {
    var path = window.location.pathname.toLowerCase();
    for (var i = 0; i < EXCLUDED.length; i++) {
      if (path.indexOf(EXCLUDED[i]) !== -1) return false;
    }
    try {
      return !sessionStorage.getItem(STORAGE_KEY);
    } catch(e) { return true; }
  }

  function markSeen() {
    try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch(e) {}
  }

  function openPopup() {
    var overlay = document.getElementById('bdg-overlay');
    if (overlay) {
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  function closePopup() {
    var overlay = document.getElementById('bdg-overlay');
    if (overlay) {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }
    markSeen();
  }

  function handleOverlayClick(e) {
    if (e.target.id === 'bdg-overlay') closePopup();
  }

  function handleKeydown(e) {
    if (e.key === 'Escape') closePopup();
  }

  function renderStock(remaining) {
    var MAX = 1000;
    var sold = MAX - remaining;
    var numEl   = document.getElementById('bdg-stock-num');
    var barEl   = document.getElementById('bdg-stock-fill');
    var textEl  = document.getElementById('bdg-stock-sold');
    var alertEl = document.getElementById('bdg-stock-alert');

    if (numEl)  numEl.textContent  = remaining;
    if (textEl) textEl.textContent = sold;
    if (barEl)  barEl.style.width  = Math.min(100, (sold / MAX) * 100) + '%';

    // Umbral de escasez crítica
    if (remaining < 300) {
      if (alertEl)  alertEl.style.display = 'block';
      if (numEl)    numEl.classList.add('bdg-pulse-red');
    } else {
      if (alertEl)  alertEl.style.display = 'none';
      if (numEl)    numEl.classList.remove('bdg-pulse-red');
    }
  }

  function startRecentPurchases() {
    var el      = document.getElementById('bdg-recent-purchase');
    var textEl  = document.getElementById('bdg-recent-text');
    if (!el || !textEl) return;

    var names = [
      'Gabriela','Sofía','Valentina','Camila','Fernanda',
      'Andrea','Paola','Alejandra','Mariana','Natalia',
      'Isabella','Daniela','Lucía','Carolina','Valeria',
      'Paula','Diana','Mónica','Rebeca','Karla',
      'Renata','Brenda','Itzel','Ximena','Lorena'
    ];
    var cities = [
      'CDMX','GDL','MTY','Puebla','Querétaro',
      'León','Cancún','Tijuana','Mérida','Toluca',
      'San Luis Potosí','Aguascalientes','Veracruz','Hermosillo','Oaxaca',
      'Morelia','Culiacán','Chihuahua','Saltillo','Xalapa'
    ];
    var times = [
      'ahora mismo','hace 1 min','hace 2 min',
      'hace 3 min','hace 4 min','hace 5 min'
    ];

    function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

    function showNext() {
      // Fade out si ya está visible
      el.classList.remove('bdg-rp-visible');
      setTimeout(function() {
        textEl.textContent = pick(names) + ' de ' + pick(cities) + ' compró ' + pick(times);
        el.classList.add('bdg-rp-visible');
      }, 400);
    }

    // Primera aparición a los 5 seg, luego rotar cada 10–16 seg
    setTimeout(function() {
      showNext();
      setInterval(showNext, Math.floor(Math.random() * 6000) + 10000);
    }, 5000);
  }

  function simulateViewers() {
    var viewEl = document.getElementById('bdg-viewers-num');
    if (!viewEl) return;
    var count = Math.floor(Math.random() * 13) + 14; // 14–26 al abrir
    viewEl.textContent = count;
    setInterval(function() {
      var delta = Math.random() < 0.55 ? 1 : -1;
      count = Math.max(8, Math.min(35, count + delta));
      viewEl.textContent = count;
    }, Math.floor(Math.random() * 3500) + 4000); // cada 4–7.5 seg
  }

  function fetchStock() {
    // Usa el stock compartido del localStorage si existe
    try {
      var stored = JSON.parse(localStorage.getItem('bdg_promo_stock') || 'null');
      if (stored && stored.stock > 0) {
        renderStock(stored.stock);
        return;
      }
    } catch(e) {}

    // Fallback: stock de Shopify API
    fetch('/products/penny-clogs.js')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var total = 0;
        if (data.variants) {
          data.variants.forEach(function(v) {
            total += (v.inventory_quantity || 0);
          });
        }
        var remaining = total > 0 ? Math.min(total, 1000) : 829;
        renderStock(remaining);
      })
      .catch(function() { renderStock(829); });
  }

  function init() {
    if (!shouldShow()) return;

    var closeBtn = document.getElementById('bdg-close');
    var skipBtn  = document.getElementById('bdg-skip');
    var overlay  = document.getElementById('bdg-overlay');

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (skipBtn)  skipBtn.addEventListener('click', closePopup);
    if (overlay)  overlay.addEventListener('click', handleOverlayClick);
    document.addEventListener('keydown', handleKeydown);

    fetchStock();
    simulateViewers();
    startRecentPurchases();
    setTimeout(openPopup, DELAY_MS);
  }

  window.bdgSelectImg = function(el) {
    var thumbs = document.querySelectorAll('.bdg-photo-thumb');
    thumbs.forEach(function(t) { t.classList.remove('active'); });
    el.classList.add('active');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
